// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3682":"aa336e0a","3993":"9485478b","8674":"cd1722df"}[chunkId] + ".chunk.css";
};